export default {
  kelasmu: require('./Kelasmu.png'),
  ujianmu: require('./Ujianmu.png'),
  karirmu: require('./Karirmu.png'),
  tanyamu: require('./Tanyamu.png'),
  cerdas: require('./cerdas.png'),
  inovatif: require('./inovatif.png'),
  berprinsip: require('./berprinsip.png'),
  berkomitmen: require('./berkomitmen.png'),
  mandiri: require('./mandiri.png'),
  bekerjasama: require('./bekerjasama.png'),
  komunikatif: require('./komunikatif.png'),
  reflektif: require('./reflektif.png'),
  tindakan: require('./tindakan.png'),
  headerbg: require('./header_bg.png'),
  dukunganmedia: require('./DukunganMedia-compressor.png'),
  bannerLembagaDesktop: require('./list_lembaga_desktop.png'),
  bannerLembagaMobile: require('./list_lembaga_mobile.png'),
  emailSent: require('./email-sent.png'),
  default: require('./default_avatar.png')
}
